import { APIGetRequest } from "@/utils/requests";
import { BackendApiRequest } from "@/utils/api";
import { SpecialWithTagInfo } from "@punchup/data/models";
import { createNoAuthSupabaseClientWithRetry } from "@/data/supabase";

export async function getSpecials(params: {
  comedianId?: string;
  comedianSlug?: string;
  collectionSlug?: string;
  collectionId?: string;
  limit?: number;
  tags?: "include" | "only";
  sort?: "newest";
}): Promise<SpecialWithTagInfo[]> {
  const queryParams = new URLSearchParams();
  if (params.comedianId) {
    queryParams.set("comedian_id", params.comedianId);
  }
  if (params.comedianSlug) {
    queryParams.set("comedian_slug", params.comedianSlug);
  }
  if (params.collectionSlug) {
    queryParams.set("collection_slug", params.collectionSlug);
  }
  if (params.collectionId) {
    queryParams.set("collection_id", params.collectionId);
  }
  if (params.limit !== undefined) {
    queryParams.set("limit", String(params.limit));
  }
  if (params.tags !== undefined) {
    queryParams.set("tags", params.tags);
  }
  if (params.sort !== undefined) {
    queryParams.set("sort", params.sort);
  }

  const response = await APIGetRequest<{
    data: SpecialWithTagInfo[];
  }>(`/api/v2/public/specials?${queryParams.toString()}`);
  return response.data;
}
